
/*
    A shell for displaying one of the trip detail components within
    the space of the trip record list

    the possible inner components are stored in the modes object below

    There will a display of buttons across the top allowing for switching between these modes
*/

import React, { createRef } from "react";

import MainContext from "../MainContext";
import Constants from "../Constants";

import BusOpsDetailsForm from "../Forms/BusOpsDetailsForm";
import BusOpsAddTripForm from "../Forms/BusOpsAddTripForm";
import BusOpsStatusAndAnnouncements from "../Containers/BusOpsStatusAndAnnouncements";
import BusOpsTimePointsListing from "../Containers/BusOpsTimePointsListing";

import TripSwapDisplay from "../DataDisplay/TripSwapDisplay";

import { scrollToRef /*, enableScroll, disableScroll */ } from "../Scripts/Utilities";

const modes = {
    TIME_POINTS: {
        label: "STOPS",
        Component: BusOpsTimePointsListing
    },
    DEPARTURE: {
        label: "DETAILS",
        Component: BusOpsDetailsForm
    },
    STATUS_AND_ANNOUNCEMENTS: {
        label: "STATUS/ANNOUNCEMENTS",
        Component: BusOpsStatusAndAnnouncements
    },
    ADD_TRIP: {
        label: "ADD TRIP",
        Component: BusOpsAddTripForm
    }
}

export default class BusOpsDetails extends React.Component {

    static contextType = MainContext;

    constructor(){
        super();
        
        this.state = {
            mode: null,
            departureUpdated: false
        };

        this.focusRef = createRef();
    }

    switchMode = (mode) => {
        this.setState({mode});
    }

    markDepartureUpdated = () => {
        this.setState({departureUpdated: true});
    }

    gotoMap = () => {
        console.log("THIS DATA", this.props.data, Constants);
        const query = [{
            key: "route",
            value: this.props.data.Route
        }];
        this.context.takeRoute("/map", Constants.routes.MAP_ROUTE, null, false, query);
    }

    componentDidMount(){
        // make sure to scroll so that the whole component is visible when first expanded
        this.setState({
            mode: this.context.user.access === Constants.access.starter 
                ? modes.DEPARTURE
                : modes.TIME_POINTS
        }, () => {
            scrollToRef(this.focusRef.current);
            // disableScroll();
            // this.props.disableScroll();
        })
    }

    render(){

        let className = "data-expanded";

        const data = this.props.data;
        const realTime = data.SecLate || data.ManualDelay;

        console.log("DATA EXPANDED", realTime, typeof(realTime), data);

        const mainStyle = {
            display: "flex",
            flexDirection: "column",
            padding: "8px 0"
        };

        // set the class based on the tripcolor - grey or blue

        if(!data || !data.tripcolor || data.tripcolor.toLowerCase() === "grey"){
            className += " data-expanded-old";
        }
        else if(data.tripcolor.toLowerCase() !== "blue"){
            mainStyle.backgroundColor = data.tripcolor.toLowerCase();
        }

        let isUsed = false;
        let tripTo = null;
        let isFilled = false;
        let tripFrom = null;

        if(data.switched){
            let alsoTo = false;
            let classAddition = " ";

            if(data.switched.tripTo){
                classAddition = " trip-open";
                isUsed = true;
                tripTo = data.switched.tripTo;
                alsoTo = true;
            }

            if(data.switched.tripFrom){
                classAddition = (alsoTo ? " trip-double-swap" : " trip-filled");
                isFilled = true;
                tripFrom = data.switched.tripFrom;
            }

            className += classAddition;
        }

        return (
            <div className={className} style={mainStyle}>
                {
                    this.state.mode
                    ? <> 
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "8px 0"
                    }}>
                        {
                            (realTime && realTime.length > 0)
                            ? <img 
                                style={{
                                    margin: "0 8px",
                                    position: "relative",
                                    right: "2vw",
                                    border: "2px solid white",
                                    borderRadius: "50%",
                                    width: "2.2rem",
                                    height: "2.2rem",
                                    boxShadow: "0 0 8px rgba(0,0,0,0.5)"
                                }} 
                                src="/map_icons/map_icon.png"
                                onClick={this.gotoMap}
                            />
                            : <span></span>
                        }
                        {
                            // loop through the modes and display them as buttons
                            // which can switch the component displayed
                            Object.values(modes).map((mode, index) => {
                                return ( 
                                <div key={index} 
                                    ref={index === 0 ? this.focusRef : null}
                                    style={{
                                        margin: "0 8px"
                                    }}
                                    className={mode === this.state.mode
                                        ? "option-selected option-low-vertical"
                                        : "option option-low-vertical"
                                    }
                                    onClick={() => this.switchMode(mode)}
                                >
                                    {mode.label}
                                </div>);
                            })
                        }
                        <div className="option option-low-vertical"
                            style={{
                                margin: "0 8px",
                                position: "relative",
                                left: "2vw"
                            }}
                            onClick={() => this.props.onClose(this.state.departureUpdated)}
                        >
                            Close
                        </div>
                    </div>
                    <div>
                        {
                            React.createElement(this.state.mode.Component, {...this.props, markDepartureUpdated: this.markDepartureUpdated})
                        }
                    </div>
                    </>
                    : null
                }
            </div>
        );
    }
}